export { default } from 'src/enterprise/signup/page';
export { getServerSideProps } from 'src/enterprise/signup/get-server-side-props';
